/**
 * Kod wygenerowany automatycznie przez automatyczne narz�dzie (problemy zg�asza� do Tomasza Grze�kiewicza)
 * nie zmieniaj tego pliku, wszystkie zmiany zostan� nadpisane automatycznie
 */
import {Api} from "../index";
import {ReactivityValidator} from "../../utils/ReactivityValidator"

export const FinalEvaluation = {

	delete (context, finalEvaluationId, onSuccess, onError, options) {
		Api.delete(context,
			"/final-evaluation"
			+ "?finalEvaluationId=" + finalEvaluationId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	get (context, finalEvaluationId, onSuccess, onError, options) {
		Api.get(context,
			"/final-evaluation"
			+ "?finalEvaluationId=" + finalEvaluationId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getConfiguration (context, contestId, onSuccess, onError, options) {
		Api.get(context,
			"/final-evaluation/configuration"
			+ "?contestId=" + contestId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getContestNames (context, onSuccess, onError, options) {
		Api.get(context,
			"/final-evaluation/contest-names"
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	postCommitteeUser (context, offerId, committeeUserId, onSuccess, onError, options) {
		Api.post(context,
			"/final-evaluation/committee-user"
			+ "?offerId=" + offerId
			+ "&committeeUserId=" + committeeUserId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	put (context, finalEvaluationId, onSuccess, onError, options) {
		Api.put(context,
			"/final-evaluation"
			+ "?finalEvaluationId=" + finalEvaluationId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	putCorrection (context, evaluationId, correctionCauseDTO, onSuccess, onError, options) {
		Api.put(context,
			"/final-evaluation/correction"
			+ "?evaluationId=" + evaluationId
			, correctionCauseDTO
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	putData (context, finalEvaluationId, finalEvaluationDTO, onSuccess, onError, options) {
		Api.put(context,
			"/final-evaluation/data"
			+ "?finalEvaluationId=" + finalEvaluationId
			, finalEvaluationDTO
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	putDisableBidderPreview (context, evaluationId, onSuccess, onError, options) {
		Api.put(context,
			"/final-evaluation/disable-bidder-preview"
			+ "?evaluationId=" + evaluationId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	putEnableBidderPreview (context, evaluationId, onSuccess, onError, options) {
		Api.put(context,
			"/final-evaluation/enable-bidder-preview"
			+ "?evaluationId=" + evaluationId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	putFinish (context, finalEvaluationId, finalEvaluationDTO, onSuccess, onError, options) {
		Api.put(context,
			"/final-evaluation/finish"
			+ "?finalEvaluationId=" + finalEvaluationId
			, finalEvaluationDTO
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

};
